import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "../Modal/Modal";
import OtpInputBox from "./OtpInputBox";
import { Input } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { useDispatch, useSelector } from "react-redux";
import { hidePrompt } from "../../../dux/prompt";
import { registerUser, sendMobileNumber, sendOtp } from "../../../dux/login";
import {
  isGetOtpPending,
  isRegisterUserPending,
  isVerifyOtpPending,
} from "../../../dux/apiStatus";
import { isUserDeactivated } from "../../../dux/login";
import LoaderForButton from "../UI/LoaderForButton";
import styles from "./LoginView.module.css";

const LoginView = ({
  userExistFlag,
  userValid,
  registered,
  otpCorrect,
  otpSent,
}) => {
  const dispatch = useDispatch();
  const [phoneNo, setphoneNo] = useState("");
  const [fname, setfname] = useState("");
  const [lname, setlname] = useState("");
  const [email, setemail] = useState("");
  const [otp, setOtp] = useState("");
  const isGetOtpLoading = useSelector(isGetOtpPending);
  const isVerifyOtpLoading = useSelector(isVerifyOtpPending);
  const isRegisterUserLoading = useSelector(isRegisterUserPending);
  const userDeactivated = useSelector(isUserDeactivated);

  const phoneChangeHandler = ({ target: { value } }) => {
    if (value.length <= 10) setphoneNo(value);
  };

  const fnameChangeHandler = ({ target: { value } }) => {
    setfname(value);
  };

  const lnameChangeHandler = ({ target: { value } }) => {
    setlname(value);
  };

  const emailChangeHandler = ({ target: { value } }) => {
    setemail(value);
  };

  // Email validation function
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const otpChangeHandler = (value) => {
    setOtp(value);
  };

  const sendOtpClickHandler = () => {
    dispatch(sendMobileNumber({ mobileNumber: phoneNo }));
  };

  const registerClickHandler = () => {
    dispatch(
      registerUser({
        firstName: fname,
        lastName: lname,
        emailAddress: email,
        mobileNumber: phoneNo,
      })
    );
  };

  const verifyOtpClickHandler = () => {
    dispatch(sendOtp({ mobileNumber: phoneNo, mobileOtp: otp }));
  };

  return (
    <Modal>
      <div className={styles.container}>
        <span className={styles.close} onClick={() => dispatch(hidePrompt())}>
          <CancelIcon />
        </span>

        <div className={styles.mobileInput}>
          {/* Success Message */}
          {registered && (
            <div
              className={styles.text}
              style={{ color: "#28a745", fontWeight: 600 }}
            >
              ✅ You have registered successfully. Please login
            </div>
          )}

          {/* Error Messages */}
          {userExistFlag && (
            <div className={styles.error}>
              ❌ User already exists. Please try logging in.
            </div>
          )}

          {userDeactivated && (
            <div className={styles.error}>
              ❌ Contact Admin, user has been inactive. Please contact the
              administrator to reactivate your account.
            </div>
          )}

          {!otpCorrect && otpSent && (
            <div className={styles.error}>
              ❌ Incorrect OTP. Please re-enter.
            </div>
          )}

          {/* Main Content */}
          <div className={styles.text}>
            {userValid
              ? "Enter Your Mobile Number"
              : "Welcome to WHS Sports Hub"}
          </div>

          <Input
            value={phoneNo}
            type="number"
            onChange={phoneChangeHandler}
            className={styles.inputField}
            placeholder="Enter your mobile number"
            disabled={!userValid}
            autoFocus
          />

          {/* Registration Form */}
          {!userValid && (
            <>
              <div
                className={styles.text}
                style={{ fontSize: "14px", color: "#6c757d" }}
              >
                Looks like you're a new user. Please enter your details!
              </div>

              <Input
                value={fname}
                onChange={fnameChangeHandler}
                className={styles.inputField}
                placeholder="First Name"
              />

              <Input
                value={lname}
                onChange={lnameChangeHandler}
                className={styles.inputField}
                placeholder="Last Name"
              />

              <Input
                type="email"
                value={email}
                onChange={emailChangeHandler}
                className={styles.inputField}
                placeholder="Email Address"
              />
            </>
          )}

          {/* Action Buttons */}
          {userValid && (
            <button
              disabled={isGetOtpLoading || phoneNo.length < 10}
              className={styles.btn}
              onClick={sendOtpClickHandler}
              key="login-btn"
            >
              {isGetOtpLoading ? <LoaderForButton /> : "Send OTP"}
            </button>
          )}

          {!userValid && (
            <button
              disabled={
                isRegisterUserLoading ||
                fname === "" ||
                lname === "" ||
                email === "" ||
                !isValidEmail(email) ||
                phoneNo.length < 10
              }
              className={styles.btn}
              onClick={registerClickHandler}
              key="register-btn"
            >
              {isRegisterUserLoading ? <LoaderForButton /> : "Register User"}
            </button>
          )}

          {/* Resend OTP */}
          {otpSent && (
            <span className={styles.resend} onClick={sendOtpClickHandler}>
              🔄 Resend OTP
            </span>
          )}
        </div>

        {/* OTP Section */}
        {otpSent && (
          <div className={styles.otp}>
            <div className={styles.text}>
              📱 OTP sent to your mobile number & email
            </div>
            <div
              className={styles.text}
              style={{ fontSize: "14px", color: "#6c757d" }}
            >
              Enter the 6-digit OTP
            </div>

            <OtpInputBox value={otp} changeHandler={otpChangeHandler} />

            <button
              className={styles.btn}
              onClick={verifyOtpClickHandler}
              disabled={isVerifyOtpLoading || otp.length < 6}
            >
              {isVerifyOtpLoading ? <LoaderForButton /> : "Verify OTP"}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

LoginView.propTypes = {
  userExistFlag: PropTypes.bool,
  userValid: PropTypes.bool,
  registered: PropTypes.bool,
  otpCorrect: PropTypes.bool,
  otpSent: PropTypes.bool,
  userDeactivated: PropTypes.bool,
};

export default LoginView;
